module.exports = __webpack_public_path__ + "img/gb-sct.31ef8bcf.svg";